export class CopilotService {
    static $inject = ['MessagingHubService'];
    constructor(MessagingHubService) {
        this.MessagingHubService = MessagingHubService;
    }
    async getCopilotTenantEnablementStatus() {
        try {
            const command = {
                method: 'get',
                uri: '/copilot/tenant/enablement-status',
                to: 'postmaster@copilot.msging.net',
            };
            return await this.MessagingHubService.processCommand(command);
        }
        catch (error) {
            console.error('Error getting copilot tenant enablement status:', error);
            return {
                resource: {
                    isAvailable: false,
                },
            };
        }
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
CopilotService.$inject = ['MessagingHubService'];
